import ErrorBoundary from "common/components/ErrorBoundary";
import Header from "common/components/Header";
import Navbar from "common/components/Navbar";
import { useAuthContext } from "common/contexts/AuthContext";
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import styled from "styled-components";

const AppGrid = styled.div`
  display: grid;
  grid-template-columns: max-content auto;
  height: 100vh;
  overflow: hidden;
`;

const AppColumnGrid = styled.div`
  display: grid;
  grid-template-rows: minmax(min-content, 5vh) 95vh;
`;

const ContentContainer = styled.div`
  background-color: white;
  height: 100%;
  overflow-y: auto;
`;

const AppLayout = () => {
  const { authConfig } = useAuthContext();
  if (!authConfig.accessToken) {
    return <Navigate to="/login" />;
  }

  return (
    <AppGrid>
      <ErrorBoundary>
        <Navbar />
      </ErrorBoundary>
      <AppColumnGrid>
        <ErrorBoundary>
          <Header />
        </ErrorBoundary>
        <ContentContainer>
          <ErrorBoundary>
            <Suspense fallback={<div>Loading your content...</div>}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </ContentContainer>
      </AppColumnGrid>
    </AppGrid>
  );
};

export default AppLayout;
